import { ApolloError } from '@apollo/client';

type ExaminationCourseValidationProperty = 'nameTH' | 'nameEN' | 'code';

interface ValidationError {
  property: ExaminationCourseValidationProperty;
  code: string;
}

const ERROR_MESSAGES: Record<ExaminationCourseValidationProperty, string> = {
  nameTH: 'ชื่อศูนย์ทดสอบนี้มีอยู่ในระบบแล้ว กรุณากรอกชื่ออื่น',
  nameEN: 'ชื่อศูนย์ทดสอบนี้มีอยู่ในระบบแล้ว กรุณากรอกชื่ออื่น',
  code: 'Exam Center Code นี้มีอยู่แล้วในระบบ กรุณากรอก Exam Center Code อื่น',
};

function getErrorMessage(code: string, property: string) {
  if (property === 'nameTH' && code === 'EXAM_CENTER_NAME_ALREADY_EXISTS') {
    return ERROR_MESSAGES.nameTH;
  }

  if (property === 'nameEN' && code === 'EXAM_CENTER_NAME_ALREADY_EXISTS') {
    return ERROR_MESSAGES.nameEN;
  }

  if (property === 'code' && code === 'EXAM_CENTER_CODE_ALREADY_EXISTS') {
    return ERROR_MESSAGES.code;
  }
}

export function transformExamCenterValidationErrors(error: unknown) {
  if (!(error instanceof ApolloError)) {
    return [];
  }

  const extensions = error.cause?.extensions;
  if (!extensions || typeof extensions !== 'object' || Array.isArray(extensions)) {
    return [];
  }

  const details = extensions.details as ValidationError[];
  if (!Array.isArray(details)) {
    return [];
  }

  return details.map(({ property, code }) => ({
    property,
    message: getErrorMessage(code, property),
  }));
}
